export class DsHtmlElement {
  static focus(fieldName: string, preventScroll = false) {
    const field = document.getElementsByName(fieldName)[0] as HTMLElement;

    //TODO Improve scroll when migrated
    if (field.getAttribute("type") !== "hidden") {
      field.focus({ preventScroll: preventScroll });
    } else {
      document.getElementById(fieldName)?.scrollIntoView();
    }
  }
}
